module.exports = __webpack_public_path__ + "assets/img/ds4.272976ca.jpg";